/**
 * Created by Alican Köker on 2018-12-19.
 */
import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import {EdisonStateReelSymbol} from "./EdisonStateReelSymbol";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";

export class EdisonSymbolController extends BaseController{

    constructor(tweakEnabled?: boolean, tweakModuleHeadline?: string, betWinMode?: BetWinMode) {
        super();
    }

    public changeSymbolState(symbol:EdisonStateReelSymbol, newState:ISymbolStateConfig):void {
        symbol.changeState({
            state : newState,
            fadeInDuration : 1,
            fadeInDelay : 0,
        });


    }

}